import Vue from 'vue'
import VueRouter from 'vue-router'
import Base from '../views/Base'
import PrimaPagina from '../views/PrimaPagina';
import Bibliografia from '../views/Bibliografia';
import Chisiamo from '../views/Chisiamo';

Vue.use(VueRouter)

const routes = [{
        path: '/',
        component: PrimaPagina
    },
    {
        path: '/orologio/',
        component: Base
    },
    {
        path: '/orologio/:page',
        component: Base
    },
    {
        path: '/bibliografia',
        component: Bibliografia
    },
    {
        path: '/chisiamo',
        component: Chisiamo
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router;